// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_jOX","cls2":"FullScreenPremiumModal-cls2_Emi FullScreenPremiumModal-cls1_jOX"};